// import Report from './Report'
export default {
  // component: Report,
  component: load(() => import(/* webpackChunkName: "Guardian-Report" */ './Report')),
  priority: 1,
  permissions: ['LastClockingsMenu'],
  name: app.translate('routes.home.guardian.Report'),
  icon: 'set-center',
  drawer: true,
};


